module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"aiSuggestion":"AI Suggestion","promptResponse":"AI Prompt Response","accept":"Accept","cancel":"Cancel","debugInfo":"Prompt run results"},"de":{"aiSuggestion":"KI-Vorschlag","promptResponse":"KI-Prompt-Antwort","accept":"Akzeptieren","cancel":"Abbrechen","debugInfo":"Prompt-Ausführungsergebnisse"}}')
  delete Component.options._Ctor
}
